import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const latest = [...newsList]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 5);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
            <div>
              <span className="text-xs font-medium tracking-[0.2em] text-primary-500 uppercase">
                News
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
                最新动态
              </h2>
            </div>
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
            >
              查看全部动态
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-col divide-y divide-background-200 bg-background-50 rounded-lg border border-background-200 overflow-hidden">
            {latest.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex flex-col md:flex-row md:items-center gap-3 md:gap-6 p-5 hover:bg-primary-50/60 transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-3 md:w-56 shrink-0">
                  <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors mb-1 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-1">{item.summary}</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors hidden md:block"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}